import api from "../../api";
import axios from "../../utils/axios.instance";
import { isNullOrEmpty } from "../../utils/helperFunction";
import handleError from "../handle-error";

export const getJobRequirementForRecruiter = async () => {
  try {
    const { data } = await axios.get(api.jobRequirement.list);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const sendHiringCompanyInvite = async (payload: {
  firstName: string;
  lastName: string;
  email: string;
}) => {
  try {
    const { data } = await axios.post(
      api.jobRequirement.invitationHiringCompany,
      payload
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getSearchHiringCompany = async (payload: {
  search?: string;
  limit: number;
  page: number;
}) => {
  try {
    let url = `${api.jobRequirement.searchHiringCompany}?page=${payload.page}&limit=${payload.limit}`;
    if (!isNullOrEmpty(payload?.search)) {
      url += `&search=${payload.search}`;
    }
    const { data } = await axios.get(url);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
